import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContextFactory } from '@shared/factories/context/context.factory';
import ExpandMenu from '../../../../assets/data/expanded-menu.json'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';
import { ConceptUtilsService } from '@shared/services/concept-utils/concept-utils.service';
import { ApiPropertiesFactory } from '@shared/factories/api-properties/api-properties.factory';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { ButtonWithTextMenuComponent } from "../../../shared/components/button-with-text-menu/button-with-text-menu.component";
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
  selector: 'public-link',
  templateUrl: './public-link.component.html',
  standalone: true,
  imports: [
    NgClass,
    AfTranslateDirective,
    AfTranslatePipe,
    ButtonWithTextMenuComponent
  ]
})

export class PublicLinkComponent implements OnInit {
  skin: string = this.globalCfg.skin;
  dataProtectionView: boolean = this.skin === 'dark-blue' || this.skin === 'steel-blue' || this.skin === 'gm-law';
  evaluationId: string = this.route.snapshot.params['evaluationId'];
  concept: any = this.dialogConfig.data.concept;
  evaluationInfo: any = this.dialogConfig.data.evaluationInfo;
  publicLink:any ={
    setGlobal: false,
    showInfo: false,
    globalConfiguration: null,
    corporativeInformation: {
      publishConcept: {},
      configurated : false,
      error: false
    },
    shareUrlItem: {expandedMenu: ExpandMenu['menuShareUrl'].menu},
    // listDocument: [],
    // protectionData: [],
    // legalData:[]
  }

  constructor(private globalCfg: GlobalCfgFactory,
    private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService,
    private loader: LoaderFactory,
    private route: ActivatedRoute,
    private modalService: ModalServiceService,
    private context: ContextFactory,
    private registerService: RegisterMixtapeService,
    private conceptUtilsService: ConceptUtilsService,
    private apiProperties: ApiPropertiesFactory,
    private dialogRef: DynamicDialogRef<PublicLinkComponent>,
    private dialogConfig: DynamicDialogConfig) {}
  @ViewChild(ButtonWithTextMenuComponent) buttonWithTextMenu: ButtonWithTextMenuComponent;

  ngOnInit(): void {
    this.publicLink.concept = this.concept;
    this.publicLink.published = this.concept.publicShared;
    this.getCustomConfiguration();
    this.getCorporativeInformation();
    this.getPublicConceptTitle();
  }

  getCorporativeInformation(){
    this.apiService.get('publicconceptcfg', 'concept/' + this.concept.conceptId)
      .then((data:any)=> {
        if(data){
          let global:boolean = false;
          data.footerDesignType = !data.footerDesignType? 3 : data.footerDesignType;
          // Si el data trae un companyId, el data es global
          data.companyId? global = true : this.fillSetCorporativeInformation(data, false);
          let corporativeInformation: any = this.publicLink.corporativeInformation;
          corporativeInformation.configurated = true;
          corporativeInformation.error = false;
          // corporativeInformation.logoImage = data.logo;
          corporativeInformation.logoImage = this.commonUtilsService.setLogo(data.logoOther, data.logo);
          corporativeInformation.faviconImg = this.commonUtilsService.setLogo(data.favIcon,data.favIcon);
          corporativeInformation.faviconFile = this.conceptUtilsService.convertToFormDataFavicon(corporativeInformation.faviconImg);
          if(data.logo){
            corporativeInformation.allLogos = this.configureLogos(data);
          }
          this.getGlobalConfiguration(global);
        }
      }, (errorData:any)=> {
        this.handleDismiss('closeError');
      });
  }

  getCustomConfiguration(){
    this.apiService.get('publicconceptcfg', + this.concept.conceptId+'/cfg-status')
    .then((data:any)=> {
      this.concept.url = data.publicUrl
      this.publicLink.processManagementOk = data.processManagement !== null && (data.processManagement.hasProcess && data.processManagement.hasGeneralTask);
      this.publicLink.additionalCfg = data.additionalCfg;
      this.publicLink.additionalCfgOk = data.additionalCfg !== null && (data.additionalCfg.hasLegalInfo || data.additionalCfg.hasDataTreatments || data.additionalCfg.hasCustomForm || data.additionalCfg.hasReferenceDocuments || data.additionalCfg.hasExtraInfo);
    }, (errorData:any)=>{})

  }

  getPublicConceptTitle(){
    this.apiService.get('publicconceptcfg', 'concept/' + this.concept.conceptId+'/landing-title')
      .then((data:any)=> {
          if(!data.length){
              data=[{conceptId: this.concept.conceptId, language: sessionStorage.getItem('selectLanguage'), title: '', numOrder: 1}]
          }else{
            this.hasDefaultLanguage(data)
        }
          this.publicLink.corporativeInformation.titleInfo = {}
          this.configureTitle(data);
      }, (errorData:any)=>{})
  }

  hasDefaultLanguage(data:any){
    let selectLanguage: any = sessionStorage.getItem('selectLanguage')
    if(!Boolean(data.filter((item:any)=>item.language === selectLanguage).length)){
      data.splice(0,0, {conceptId: this.publicLink.concept.conceptId, language: selectLanguage, title: '', numOrder: 1})
    }
  }

  configureTitle(data:any){
    this.publicLink.selectLanguages = [];
    this.configureSelectedLanguages(data)
    this.publicLink.corporativeInformation.titleInfo = {
      defaultLanguage: sessionStorage.getItem('selectLanguage'),
      concept: this.concept,
      languagesApp: this.context.settings.languagesApp,
      selectedLanguages: this.publicLink.selectLanguages,
      languageSelected: this.publicLink.languageSelected
    };
  }

  configureSelectedLanguages(data:any){
    for(let i = 0; i < data.length; i++){
      let selectedLanguage = data[i];
      let textDefault = selectedLanguage.language === sessionStorage.getItem('selectLanguage');
      this.selectListLanguagesSelected(selectedLanguage, textDefault);
    }
  }

  selectListLanguagesSelected( selectedLanguage:any, textDefault:any){
    this.publicLink.languages = this.commonUtilsService.configureAvailableLanguages(this.apiProperties.availableLanguages);
      for(let i = 0; i < this.publicLink.languages.length; i++){
          let language = this.publicLink.languages[i];
          language.indexListLanguage = i;
          if(language.listValueId === selectedLanguage.language){
              language.selected = true;
              language.preSelectItem = selectedLanguage.title;
              language.defaultOption = textDefault;
              language.active = language.listValueId === sessionStorage.getItem('selectLanguage');
              this.publicLink.selectLanguages.push(language);
              this.publicLink.chargedLiteralDefault = true;
              if(language.active){
                  this.publicLink.languageSelected = language;
              }
              break;
          }
      }
  }

  fillSetCorporativeInformation(data:any, global:boolean){
    // if(!data.textColor && data.color){
    //     data.textColor = data.color.toLowerCase() === '#fff201' || data.color.toLowerCase() === '#ffb001'? '#000000' : '#ffffff';
    // }
    this.publicLink.corporativeInformation.faviconImg = this.commonUtilsService.setLogo(data.favIcon, data.favIcon);
    this.publicLink.corporativeInformation.faviconFile = this.conceptUtilsService.convertToFormDataFavicon(this.publicLink.corporativeInformation.faviconImg);
    this.publicLink.corporativeInformation.publishConcept = {
      color: data.color,
      textColor: data.textColor,
      footerDesignType: data.footerDesignType,
      youtube: data.youtube,
      twitter: data.twitter,
      facebook: data.facebook,
      linkedin: data.linkedin,
      instagram: data.instagram,
      phone: data.phone,
      footer: data.footer,
      showLogoInFooter: data.showLogoInFooter,
      customEmail: data.customEmail,
      smtpServer: data.smtpServer,
      smtpPort: data.smtpPort === null?'': data.smtpPort,
      smtpUser: data.smtpUser === null?'': data.smtpUser,
      smtpPassword: data.smtpPassword,
      smtpFrom: data.smtpFrom,
      smtpssl: data.smtpssl,
      oauthReconfigNeeded: data.oauthReconfigNeeded,
      oauthUser: data.oauthUser,
      oauthAccessToken: data.oauthAccessToken,
      sharedPublicConceptConfigurationId: data.sharedPublicConceptConfigurationId,
      global: global
    };
    this.prevConfigureChannelConfiguration(global);
  }

  prevConfigureChannelConfiguration(global:boolean){
    let channelConfiguration:any = {};
    if(this.publicLink.corporativeInformation && this.publicLink.corporativeInformation.publishConcept){
      channelConfiguration = {
        color: this.publicLink.corporativeInformation.publishConcept.color,
        textColor: this.publicLink.corporativeInformation.publishConcept.textColor,
        logo: this.publicLink.corporativeInformation.logoImage,
        configurated: this.publicLink.corporativeInformation.configurated,
        global: global
      };
    }
    this.configureChannelCorporativeInformation(channelConfiguration);
  }

  configureChannelCorporativeInformation(channelConfiguration:any){
    if(this.concept.channelView){
      this.concept.channelCorporativeInformation.color = channelConfiguration.color;
      this.concept.channelCorporativeInformation.textColor = channelConfiguration.textColor;
      this.concept.channelCorporativeInformation.global = channelConfiguration.global;
      this.concept.channelCorporativeInformation.configurated = channelConfiguration.configurated;
      this.concept.channelCorporativeInformation.logo = channelConfiguration.logo;
    }
  }

  configureLogos(data:any){
    return {
      logo: this.commonUtilsService.setLogo(data.logo, data.logo),
      logo320X55: this.commonUtilsService.setLogo(data.logoFooter, data.logo),
      logo260X45: this.commonUtilsService.setLogo(data.logoHeader, data.logo),
      logo290X50: this.commonUtilsService.setLogo(data.logoOther, data.logo)
    }
  }

  getGlobalConfiguration(setGlobal:any){
    this.apiService.get('company','globalcustomization/'+this.context.user.companyId)
      .then((dataglobal:any)=>{
        this.publicLink.globalConfiguration = dataglobal;
        this.publicLink.corporativeInformation.globalConfiguration = dataglobal;
        if(setGlobal){
          this.fillSetCorporativeInformation(dataglobal, setGlobal);
          this.publicLink.corporativeInformation.allLogos = this.configureLogos( this.publicLink.globalConfiguration);
          if(this.concept.channelView){
            this.concept.channelCorporativeInformation.logo = this.publicLink.corporativeInformation.allLogos.logo;
          }
        }else{
          this.prevConfigureChannelConfiguration(setGlobal);
        }
      },(errorData:any)=>{
        this.prevConfigureChannelConfiguration(setGlobal);
      });
  }

  editCorporativeInformation(){
    this.modalService.corporativeInformation(this.concept, this.evaluationInfo.clientId, this.publicLink.corporativeInformation)
      .subscribe((result:any) => {
        this.publicLink.listSelectedLanguages = result.listSelectedLanguages;
        if(result.result==='global'){
          this.publicLink.corporativeInformation.publishConcept.global = true;
          this.deleteConfig(this.publicLink.corporativeInformation.publishConcept.global);
          // setTimeout(()=> {
            this.modalService.successModal({ text: this.translate.instant('corporative-information-modal.configuration-save') });
          // });
        }else if(result.result === 'ok'){
          let global;
          if(this.publicLink.corporativeInformation.globalConfiguration){
            global = this.publicLink.corporativeInformation.globalConfiguration;
          }
          this.publicLink.corporativeInformation = {
            configurated: this.publicLink.corporativeInformation.configurated,
            titleInfo: this.publicLink.corporativeInformation.titleInfo,
            logo: result.logo,
            allLogos:this.getAllLogos(result),
            logoImage: result.logoImage,
            publishConcept: result.publishConcept,
            faviconImg: result.faviconImg,
            faviconFile: result.faviconFile
          };
          if(global){
            this.publicLink.corporativeInformation.globalConfiguration = global;
          }
          if(!result.setGlobal){
            this.checkLanguageTitle(result.titleInfo)
            this.configureCorporativeInformation(this.concept, this.publicLink.corporativeInformation, result.new);
          }
          this.publicLink.customSpecific = !result.setGlobal;
          let channelConfiguration = {
            color: this.publicLink.corporativeInformation.publishConcept.color,
            textColor: this.publicLink.corporativeInformation.publishConcept.textColor,
            logo: this.publicLink.corporativeInformation.logoImage,
            configurated: true,
            global: result.setGlobal
          };
          this.configureChannelCorporativeInformation(channelConfiguration);
        }else if(result.result ==='not-modify'){
          this.updateCorporativeMultilanguage();
          this.checkLanguageTitle(result.titleInfo);
          this.modalService.successModal({ text: this.translate.instant('corporative-information-modal.configuration-save') });
        }
      })
  }

  checkLanguageTitle(list:any){
    let listTitleInfo = this._getNonEmptyTitles(list);
    this._updateTitleList(listTitleInfo);
  }

  private _getNonEmptyTitles(list: any): any [] {
    let listTitleInfo:any = [];
    this.publicLink.corporativeInformation.titleInfo = {}
    for(let i = 0; i < list.length; i++){
      let language = list[i]
      if(language.preSelectItem !== ''){
        listTitleInfo.push({
          conceptId: this.concept.conceptId,
          language:  language.listValueId,
          numOrder: i+1,
          title: language.preSelectItem
        })
      }
    }
    return listTitleInfo;
  }

  private _updateTitleList(listTitleInfo: any []) {
    this.apiService.update('publicconceptcfg/concept/' + this.concept.conceptId, 'landing-title', listTitleInfo)
      .then((data:any)=>{
        this.hasDefaultLanguage(listTitleInfo);
        this.configureTitle(listTitleInfo);
      }, (errorData)=>{
        this.configureTitle(listTitleInfo);
      });
  }

  editReferenceDocument(){
    let configuration:any = {
      additionalCfg: this.publicLink.additionalCfg,
      concept: this.concept
    };
    this.modalService.referenceDocument(configuration).subscribe((result:any) => {
      this.publicLink.additionalCfgOk = result.additionalCfgOk;
      if( this.concept.channelView){
        this.concept.referenceDocuments = result.referenceDocuments;
        if(this.dataProtectionView){
          this.concept.protectionData = this.conceptUtilsService.addProtectionData(result.protectionData);
          this.concept.additionalData = this.conceptUtilsService.addProtectionData(result.additionalData);
          this.concept.legalData = this.conceptUtilsService.addProtectionData(result.legalData);
        }
      }
    });
  }

  processManagement(){
    this.modalService.processOpsModal(this.evaluationInfo, this.publicLink.concept, 'public-link').subscribe((result:any)=>{
      if(result.result === 'ok'){
        this.publicLink.processManagementOk = (result.concept.processId && result.concept.taskProcess)?true:false;
        this.concept.processId = result.concept.processId;
        this.concept.taskProcess = result.concept.taskProcess;
        if(this.concept.processId && this.concept.taskProcess){
          this.publicLink.errorHasProcessOps = false;
        }
      }
    })
  }

  publishConcept(){
    if(this.publicLink.published){
      this.changePublicShared(this.concept, false, 'unpublish');
    }else{
      let resgisterItem ={
        event:'publish public link',
        conceptName:sessionStorage.getItem('breadcrumbConcept') + this.publicLink.concept.title
      }
      this.registerService.register(resgisterItem);
      let processConfigurated:boolean = this.concept.publicLite?true : (this.concept.processId && this.concept.taskProcess);
      if(this.publicLink.corporativeInformation.configurated && processConfigurated){
          this.changePublicShared(this.concept, true);
      }else{
        this.publicLink.corporativeInformation.error = (!this.publicLink.corporativeInformation.configurated);
        this.publicLink.errorHasProcessOps = !(this.concept.processId && this.concept.taskProcess);
      }
    }
  }

  changePublicShared(concept:any, publicSharedStatus:boolean, unpublish:string = '') {
    this.loader.openLoader('folder-public-shared')
    this.apiService.patch('concepts/' + this.evaluationInfo.evaluationId + '/' + concept.conceptId + '/setpublic/' + publicSharedStatus).then(
      (data:any)=>{
        concept.publicShared = publicSharedStatus;
        if(this.publicLink.setGlobal){
          this.modalService.successModal({ text: this.translate.instant('corporative-information-modal.configuration-save') });
          this.fillSetCorporativeInformation(this.publicLink.globalConfiguration, this.publicLink.setGlobal);
        }
        if(unpublish === 'unpublish'){
          this.publicLink.published = false;
          this.publicLink.publishButton = this.translate.instant('expanded-menu.publish');
          let channelConfiguration:any = {
            global: false,
            configurated: null
          };
          if(this.publicLink.globalConfiguration){
            channelConfiguration = this.publicLink.globalConfiguration;
            channelConfiguration.global = true;
            channelConfiguration.configurated = this.publicLink.corporativeInformation.configurated;
            if(!channelConfiguration.textColor){
                channelConfiguration.textColor = channelConfiguration.color.toLowerCase() === '#fff201' || channelConfiguration.color.toLowerCase() === '#ffb001'? '#000000' : '#ffffff';
            }
          }
          this.configureChannelCorporativeInformation(channelConfiguration);
          this.handleDismiss('unpublish');
        }else if(publicSharedStatus){
          this.handleAccept();
        }
      },
      (error:any) => {
        console.error(error);
      }
    ).finally(() => {
      this.loader.closeLoader('folder-public-shared');
    });
  }

  deleteConfig(global:any){
    let sharedPublicConceptConfigurationId:any = this.publicLink.corporativeInformation.publishConcept.sharedPublicConceptConfigurationId
    this.apiService.delete('publicconceptcfg', sharedPublicConceptConfigurationId)
    .then((data:any)=>{
      this.getGlobalConfiguration(global);
    }, (error:any)=>{})
  }

  getAllLogos(result:any){
    return {
      logo: result.listLogos? result.listLogos[0].html.toDataURL('image/png') : result.logoImage,
      logo260X45: result.listLogos? result.listLogos[3].html.toDataURL('image/png') : result.logoImage,
      logo320X55: result.listLogos? result.listLogos[2].html.toDataURL('image/png') : result.logoImage,
      logo290X50: result.listLogos? result.listLogos[1].html.toDataURL('image/png') : result.logoImage,
    }
  }

  configureCorporativeInformation(concept:any, publishConcept:any, nuevo:any = undefined){
    let corporativeInformation: any = this.publicLink.corporativeInformation;
    this.loader.openLoader('folder-share-public-concept')
    corporativeInformation.configurated && corporativeInformation.publishConcept.sharedPublicConceptConfigurationId && !nuevo? this.updateCorporativeInfo(concept, publishConcept) : this.addCorporativeInfo(concept, publishConcept);
  }

  updateCorporativeInfo(concept:any, publishConcept:any){
    this.apiService.update('publicconceptcfg', undefined, publishConcept.publishConcept)
      .then((data:any)=>{
        if (data !== null && data !== '') {
          this.configureFaviconCalls(data, publishConcept);
          this.addLogoToCorporativeInformation(concept, publishConcept, data);
        }else{
          this.changePublicShared(concept, false);
        }
        this.updateCorporativeMultilanguage();
      }, (error:any)=> {
        this.loader.closeError();
      })
  }

  addCorporativeInfo(concept:any, publishConcept:any){
    this.apiService.add('publicconceptcfg', publishConcept.publishConcept)
      .then((data:any)=>{
        if (data !== null && data !== '') {
          this.publicLink.corporativeInformation.publishConcept.sharedPublicConceptConfigurationId = data.sharedPublicConceptConfigurationId;
          this.addLogoToCorporativeInformation(concept, publishConcept, data);
          this.configureFaviconCalls(data, publishConcept);
        }else{
          this.changePublicShared(concept, false);
        }
        this.updateCorporativeMultilanguage();
      }, ()=> {
        this.loader.closeError();
      })
  }

  configureFaviconCalls(published:any, publishConcept: any){
    if(publishConcept.faviconFile){
      this.addFaviconToCorporativeInformation(published, publishConcept);
    }else{
      this.removeFavicon();
    }
  }

  addFaviconToCorporativeInformation(published:any, publishConcept: any){
    this.apiService.attachFilePatch('publicconceptcfg/'+ published.sharedPublicConceptConfigurationId+'/favicon', publishConcept.faviconFile)
      .then((data:any)=>{}, (errorData:any)=>{});
  }

  removeFavicon(){
    this.apiService.patch('company/removefaviconbyconceptid', this.concept.conceptId )
      .then((data:any) => {
      }, (errorData:any)=>{
        this.loader.closeError();
      });
  }

  addLogoToCorporativeInformation(concept:any, publishConcept:any,  published:any){
    this.apiService.attachFilePatch('publicconceptcfg/'+ published.sharedPublicConceptConfigurationId+'/logos', publishConcept.logo)
      .then((data:any)=>{
        this.publicLink.corporativeInformation.configurated = true;
        this.loader.closeLoader(['folder-share-public-concept']);
        this.modalService.successModal({ text: this.translate.instant('corporative-information-modal.configuration-save') });
      }, (errorData:any)=>{
        this.loader.closeError();
        this.changePublicShared(concept, false);
      });
  }

  updateCorporativeMultilanguage(){
    let sharedPublicConceptConfigurationId: any = this.publicLink.corporativeInformation.publishConcept.sharedPublicConceptConfigurationId;
    this.setSharedPublicConcept(sharedPublicConceptConfigurationId)
    let allLanguagesEmpty = true;
    for (let i = 0; i < this.publicLink.listSelectedLanguages?.length; i++) {
      if (this.publicLink.listSelectedLanguages[i].text !== '') {
        allLanguagesEmpty = false;
        break;
      }
    }
    this.apiService.update(`publicconceptcfg/${sharedPublicConceptConfigurationId}`,'footers', allLanguagesEmpty ? [] : this.publicLink.listSelectedLanguages)
    .then((data:any)=>{},(errorData:any)=>{})
  }

  setSharedPublicConcept(sharedPublicConceptConfigurationId:any){
    this.publicLink.listSelectedLanguages.forEach((item:any) => {
      item.sharedPublicConceptConfigurationId = sharedPublicConceptConfigurationId
    });
  }

  launchActionLink(option: any){
    let configuration: any = {
      evaluationId: this.evaluationInfo.evaluationId,
      conceptId: this.concept.conceptId,
      text: this.concept.url,
      action: option.action,
      buttonCopyTooltip: this.buttonWithTextMenu,
      typeButtonTooltip: 'buttonWithTextMenu',
      time: 2000
    }
    this.conceptUtilsService.selectOptionsLink(configuration);
  }

  handleAccept() {
    this.dialogRef.close({ result : 'ok' });
  }

  handleDismiss(close:string = '') {
    this.dialogRef.close({
      result: 'cancel',
      close: close
    });
  }
}
